<template>
<div>
    <news-item v-for="(item, index) in items" :item="item" :index="index" v-if="index < visibleCount"></news-item>
    <div class="row justify-content-center" v-if="items.length === 0">
        <div class="col-sm-10">
            <div class="row main-news">
                <div class="col-6 text-content">
                    <h2 class="section-title text-left">Momentan gibt es nichts Neues.</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center" v-if="items.length > visibleCount">
        <div class="col-12 col-lg-10 p-lg-0">
            <div class="row items-row">
                <div id="more"
                     class="col col-md-4 btn-container square-item ml-md-auto d-flex justify-content-center">
                    <div class="btn-more-container align-self-center">
                        <button type="button" class="btn btn-more" @click="showMore">
                            <span>Mehr News laden</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewsItem from "./NewsItem";
export default {
    name: "News",
    components: {NewsItem},
    props: ['items'],
    data() {
        return {
            items: [],
            visibleCount: 3,
        }
    },
    computed: {

    },
    methods: {
        showMore() {
            this.visibleCount += 3;
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/js/components/News.vue